// export const target = {
//   targetGroup: {
//     id: 30,
//     organizationId: 28,
//     targetGroupId: 11,
//     active: true,
//     creditTarget: 50,
//     maxTransfer: 2,
//     welcomeMsg: 'Welcome',
//     subCredit: [
//       {
//         id: 98,
//         credit: 10,
//         eventTypeId: 12,
//         targetGroupSettingId: 30,
//         eventType: {
//           id: 12,
//           name: 'Workshop',
//           color: '#ff6d00'
//         }
//       },
//       {
//         id: 99,
//         credit: 10,
//         eventTypeId: 11,
//         targetGroupSettingId: 30,
//         eventType: {
//           id: 11,
//           name: 'Camp',
//           color: '#03a9f4'
//         }
//       },
//       {
//         id: 100,
//         credit: 10,
//         eventTypeId: 13,
//         targetGroupSettingId: 30,
//         eventType: {
//           id: 13,
//           name: 'Sport',
//           color: '#ffa726'
//         }
//       },
//       {
//         id: 101,
//         credit: 10,
//         eventTypeId: 15,
//         targetGroupSettingId: 30,
//         eventType: {
//           id: 15,
//           name: 'Konf-Weg',
//           color: '#aa00ff'
//         }
//       },
//       {
//         id: 102,
//         credit: 10,
//         eventTypeId: 16,
//         targetGroupSettingId: 30,
//         eventType: {
//           id: 16,
//           name: 'Gottesdienst',
//           color: '#d50000'
//         }
//       }
//     ]
//   },
//   status: [
//     {
//       id: 5,
//       status: 'Level 1',
//       badge: '1541163237274first.png',
//       level: 'first steps',
//       sort: 10
//     },
//     {
//       id: 6,
//       status: 'Level 2',
//       badge: '1541163243725first.png',
//       level: 'first steps',
//       sort: 2
//     },
//     {
//       id: 7,
//       status: null,
//       badge: '1541163418559church.png',
//       level: 'Konfirmation',
//       sort: null
//     },
//     {
//       id: 8,
//       status: null,
//       badge: '1541164591053badge.png',
//       level: 'Firm-Weg',
//       sort: null
//     }
//   ],
//   color: 'cyan'
// };

export const credits = {
  reward: [
    { credits: 10, eventTypeId: 11 },
    { credits: 10, eventTypeId: 13 },
    { credits: 25, eventTypeId: 15 },
    { credits: 5,  eventTypeId: 16 }
    ],
  possible: [
    { credits: 3,  eventTypeId: 17 },
    { credits: 12, eventTypeId: 10 }
    ]
};
